import React from "react";
import "./transaction.scss";

const Transaction = () => {
  return (
    <div className="wrapper_profile_details wrapper_transaction">
      <div className="land_tittle">
        <h2 className="title">My Transaction</h2>
      </div>
      <div className="wrapper_details">
        <div className="container">
          <div className="wrap_details">
            <div className="wrap_table table-responsive">
              <table>
                <thead>
                  <tr>
                    <th>S.No</th>
                    <th>Date</th>
                    <th>Amount</th>
                    <th>Transaction for</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>1</td>
                    <td>30 Days</td>
                    <td>60 Days</td>
                    <td>90 Days</td>
                  </tr>
                  <tr>
                    <td>2</td>
                    <td>Unlimited</td>
                    <td>Unlimited</td>
                    <td>Unlimited</td>
                  </tr>
                  <tr>
                    <td>3</td>
                    <td>Rs. 650.00</td>
                    <td>Rs. 1300.00</td>
                    <td>Rs. 1950.00</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Transaction;
